import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import ReactSelect from '@components/atoms/ReactSelect';
import { FormGroup } from '@components/molecules/form/FormGroup';
import { Button } from '@components/atoms/Button';
import { SelectOption } from '@components/atoms/ReactSelect';
import { Z_INDEX } from '@constants/zIndex';
import { useTranslation } from '@hooks/useTranslation';

interface AddSubtaskModalProps {
  isOpen: boolean;
  availableTasks: SelectOption[];
  onAdd: (taskIds: string[]) => void;
  onCancel: () => void;
  isLoading?: boolean;
}

export const AddSubtaskModal: React.FC<AddSubtaskModalProps> = ({
  isOpen,
  availableTasks,
  onAdd,
  onCancel,
  isLoading = false
}) => {
  const tTaskDetail = useTranslation('taskDetail');
  const [selectedTaskIds, setSelectedTaskIds] = useState<SelectOption[]>([]);

  if (!isOpen) return null;

  const handleAdd = () => {
    if (selectedTaskIds.length > 0) {
      const taskIds = selectedTaskIds.map((option) => String(option.value));
      onAdd(taskIds);
      setSelectedTaskIds([]);
    }
  };

  const modalContent = (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center"
      style={{ zIndex: Z_INDEX.EMERGENCY_MODAL }}>
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <div className="flex items-center mb-4">
          <h3 className="text-lg font-medium text-gray-900">{tTaskDetail.general.addSubtaskTitle}</h3>
        </div>

        <FormGroup
          htmlFor="subtask-select"
          label={tTaskDetail.general.selectTasksToAddLabel}>
          <ReactSelect
            isMulti
            options={availableTasks}
            value={selectedTaskIds}
            onChange={(options: any) => setSelectedTaskIds(options || [])}
            placeholder={tTaskDetail.general.chooseTasksPlaceholder}
            isDisabled={isLoading}
          />
        </FormGroup>

        <div className="flex justify-end space-x-3 mt-4">
          <Button type="button" onClick={onCancel} disabled={isLoading}>
            {tTaskDetail.general.cancel}
          </Button>
          <Button
            type="button"
            onClick={handleAdd}
            disabled={isLoading || selectedTaskIds.length === 0}>
            {isLoading ? (
              <>
                <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent inline-block mr-2"></div>
                {tTaskDetail.general.adding}
              </>
            ) : selectedTaskIds.length > 1 ? (
              tTaskDetail.general.addSubtasksButton
            ) : (
              tTaskDetail.general.addSubtaskButton
            )}
          </Button>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};